import { render, staticRenderFns } from "./create-or-edit-data-item.vue?vue&type=template&id=38609d22&scoped=true"
import script from "./create-or-edit-data-item.vue?vue&type=script&lang=js"
export * from "./create-or-edit-data-item.vue?vue&type=script&lang=js"
import style0 from "./create-or-edit-data-item.vue?vue&type=style&index=0&id=38609d22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38609d22",
  null
  
)

export default component.exports